var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 33.8125V45.7516H44.5V33.8125",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 18.25H43.5625C43.834 18.2501 44.0982 18.3385 44.315 18.502C44.5317 18.6655 44.6894 18.8952 44.7641 19.1562L47 27H17L19.2406 19.1562C19.3151 18.896 19.472 18.6669 19.6879 18.5034C19.9037 18.34 20.1668 18.2511 20.4375 18.25Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27V29.5C27 30.8261 26.4732 32.0979 25.5355 33.0355C24.5979 33.9732 23.3261 34.5 22 34.5C20.6739 34.5 19.4021 33.9732 18.4645 33.0355C17.5268 32.0979 17 30.8261 17 29.5V27",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 27V29.5C37 30.8261 36.4732 32.0979 35.5355 33.0355C34.5979 33.9732 33.3261 34.5 32 34.5C30.6739 34.5 29.4021 33.9732 28.4645 33.0355C27.5268 32.0979 27 30.8261 27 29.5V27",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 27V29.5C47 30.8261 46.4732 32.0979 45.5355 33.0355C44.5979 33.9732 43.3261 34.5 42 34.5C40.6739 34.5 39.4021 33.9732 38.4645 33.0355C37.5268 32.0979 37 30.8261 37 29.5V27",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon8.7f2a3f47d4053b52289a2c6b32e9a8c3.svg";
export { ForwardRef as ReactComponent };